import React from 'react';
import { MapPin, Zap } from 'lucide-react';
import { serviceAreas } from '../data/mock';

const ServiceAreasSection = () => {
  return (
    <section id="areas" className="py-16 sm:py-24 relative overflow-hidden" style={{ backgroundColor: '#f7f3ed' }}>
      {/* Decorative Hexagon */}
      <div className="absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 opacity-5">
        <div 
          className="w-64 h-64 sm:w-96 sm:h-96"
          style={{
            clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
            backgroundColor: '#3a2a23'
          }}
        />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold mb-4" style={{ backgroundColor: '#3a2a23', color: '#d4c19c' }}>
            <MapPin className="w-4 h-4" />
            Where We Work
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4" style={{ color: '#3a2a23' }}>
            Service Areas
          </h2>
          <p className="text-base sm:text-xl max-w-2xl mx-auto px-4" style={{ color: '#5c4a3d' }}>
            Proudly serving the Greater Golden Horseshoe region of Ontario, Canada
          </p>
        </div>

        {/* Areas Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 max-w-4xl mx-auto">
          {serviceAreas.map((area, index) => (
            <div 
              key={index}
              className={`flex items-center gap-2 sm:gap-3 p-3 sm:p-4 rounded-xl transition-all duration-300 cursor-default ${
                index === 0 
                  ? 'shadow-lg transform scale-[1.02] sm:scale-105' 
                  : 'hover:shadow-md hover:-translate-y-1'
              }`}
              style={{
                backgroundColor: index === 0 ? '#3a2a23' : 'white',
                border: index === 0 ? 'none' : '2px solid #e8e0d4',
                boxShadow: index === 0 ? '0 10px 30px rgba(58, 42, 35, 0.25)' : undefined
              }}
            >
              {/* Hexagonal Pin Icon */}
              <div 
                className="w-7 h-7 sm:w-8 sm:h-8 flex-shrink-0 relative flex items-center justify-center"
                style={{
                  clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                  backgroundColor: index === 0 ? '#d4c19c' : '#e8e0d4'
                }}
              >
                <MapPin 
                  className="w-3 h-3 sm:w-4 sm:h-4" 
                  style={{ color: index === 0 ? '#3a2a23' : '#9c7c5e' }}
                />
              </div>
              <span 
                className="font-semibold text-sm sm:text-base"
                style={{ color: index === 0 ? '#d4c19c' : '#3a2a23' }}
              >
                {area}
              </span>
              {index === 0 && (
                <span 
                  className="hidden sm:inline ml-auto text-[10px] sm:text-xs px-2 py-1 rounded-full font-bold"
                  style={{ backgroundColor: '#d4c19c', color: '#3a2a23' }}
                >
                  Primary
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="text-center mt-8 sm:mt-12">
          <p className="text-sm sm:text-base" style={{ color: '#5c4a3d' }}>
            Don't see your area? <span className="font-semibold" style={{ color: '#3a2a23' }}>Contact us to check availability.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
